import React from "react";
import Partener from "../home/Partener";
import AboutSection from "./AboutSection";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "@styles/react/libs/swiper/swiper.scss";
import "@styles/sass/5-pages/about.scss";

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("About us")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("About us")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container__video">
        <AboutSection t={t} />
      </div>
      {/* <Countingpart t={t} /> */}
      {/* <div className="container__video">
        <Review t={t} />
      </div> */}
      {/* <Partener t={t} /> */}
    </div>
  );
};

export default About;
